// eslint-disable-next-line import/prefer-default-export
export function formattedPhone({ phone }) {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}
